import { isProduction } from '@/common/environment';
import { isMexLiteTenant, isOvoTenant } from '@/common/Tenants';

export interface TenantSyncConfig {
  name: string;
  tenantSeq: number;
  featureFlagKey: string;
  badgeColor: string;
  getPortalBaseUrl: () => string;
  getRolloutUrl: (variableName: string) => string;
  isCurrentTenant: () => boolean;
}

export const GRAB_TENANT_SEQ = 1;

const ovoConfig: TenantSyncConfig = {
  name: 'OVO',
  tenantSeq: 3,
  featureFlagKey: 'tenantFlag:showSyncToOVO',
  badgeColor: 'purple',
  getPortalBaseUrl: () =>
    isProduction ? 'https://ovo.grab-x.net' : 'https://ovo-stg.grab-x.net',
  getRolloutUrl: (variableName) =>
    `${ovoConfig.getPortalBaseUrl()}/t/variables/${encodeURIComponent(variableName)}/rollout`,
  isCurrentTenant: () => isOvoTenant(),
};

const mexliteConfig: TenantSyncConfig = {
  name: 'MexLite',
  tenantSeq: 7,
  featureFlagKey: 'tenantFlag:showSyncToMexLite',
  badgeColor: 'blue',
  getPortalBaseUrl: () =>
    isProduction
      ? 'https://mexlite.grab-x.net'
      : 'https://mexlite-stg.grab-x.net',
  getRolloutUrl: (variableName) =>
    `${mexliteConfig.getPortalBaseUrl()}/t/variables/${encodeURIComponent(variableName)}/rollout`,
  isCurrentTenant: () => isMexLiteTenant(),
};

export const TENANT_CONFIGS: Record<string, TenantSyncConfig> = {
  ovo: ovoConfig,
  mexlite: mexliteConfig,
};

export const ALL_TENANT_CONFIGS = Object.values(TENANT_CONFIGS);
